module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-wall', {
    attrs: {
      "backImg": _vm.backImg
    }
  }, [_c('p', {
    slot: "title"
  }, [_vm._v("新闻动态")]), _vm._v(" "), _c('div', {
    staticClass: "news"
  }, [_c('ul', _vm._l((_vm.newsLists), function(newsList, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "news-top"
    }, [_c('p', {
      staticClass: "news-title"
    }, [_vm._v(_vm._s(newsList.title))]), _vm._v(" "), _c('span', {
      staticClass: "news-line"
    }), _vm._v(" "), _c('span', {
      staticClass: "news-right"
    }, [_vm._v(_vm._s(newsList.website) + " " + _vm._s(newsList.date))])]), _vm._v(" "), _c('p', {
      staticClass: "news-content"
    }, [_vm._v(_vm._s(_vm._f("newListCut")(newsList.content)) + " "), _c('span', {
      on: {
        "click": function($event) {
          _vm.goToUrl(newsList.url)
        }
      }
    }, [_vm._v("点击查看>>")])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70bb1494"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about/News.vue
// module id = 204
// module chunks = 1